import { useRef, type RefObject } from 'react'

export const useLazyInitializedRef = <T,>(fn: () => T): RefObject<T> => {
  const ref = useRef<T | null>(null)

  if (ref.current === null) {
    ref.current = fn()
  }
  // bypassing the null type, we ensure that the ref is always defined with the type of T
  // oxlint-disable-next-line @typescript-eslint/consistent-type-assertions
  return ref as RefObject<T>
}
